import { CommentEntity } from "@/modules/social/entities/socialEntity"
import type { CommentDto, ReactionSocialPostDto } from "@/modules/social/gateway/socialDto"
import { ReactionSocialPostEntityBuilder } from "@/modules/social/tests/reactionSocialPostEntity.builder"

const DEFAULT_USER = {
  id: "user-1",
  username: "johndoe",
  firstname: "John",
  lastname: "Doe",
  avatar: null,
}

export class CommentEntityBuilder {
  private dto: CommentDto

  static create() {
    return new CommentEntityBuilder()
  }

  protected constructor() {
    this.dto = {
      id: "comment-1",
      text: "A test comment",
      parentCommentId: null,
      childrenComments: [],
      userDto: { ...DEFAULT_USER },
      creationDate: "2025-01-20T11:00:00.000Z",
      reactions: ReactionSocialPostEntityBuilder.create().buildDto(),
      mentions: [],
      childrenCount: 0,
    }
  }

  withId(id: string): this {
    this.dto.id = id
    return this
  }

  withText(text: string): this {
    this.dto.text = text
    return this
  }

  withUser(user: Partial<typeof DEFAULT_USER>): this {
    this.dto.userDto = { ...DEFAULT_USER, ...user }
    return this
  }

  withNoUser(): this {
    this.dto.userDto = null
    return this
  }

  withReactions(reactionsDto: ReactionSocialPostDto): this {
    this.dto.reactions = reactionsDto
    return this
  }

  withParentCommentId(id: string): this {
    this.dto.parentCommentId = id
    return this
  }

  withChildrenCount(n: number): this {
    this.dto.childrenCount = n
    return this
  }

  withCreationDate(iso: string): this {
    this.dto.creationDate = iso
    return this
  }

  withMentions(mentions: CommentDto["mentions"]): this {
    this.dto.mentions = mentions
    return this
  }

  build(): CommentEntity {
    return CommentEntity.fromDto(this.dto)
  }

  buildDto(): CommentDto {
    return this.dto
  }
}
